module.exports = __webpack_public_path__ + "static/media/point.5311c7d6.png";